// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f26f572b","455":"f529e721","977":"22bb957f"}[chunkId] + ".chunk.js";
};